import React from "react";
import PropTypes from "prop-types";

const FieldsetSubHeader = (props) => {
    const { level } = props;
    let subHeaderLevel = level ? level : 1;
    let style = { marginBottom: '15px' };
    const linkText = props.linkText ? props.linkText : "";
    const linkUrl = props.linkUrl ? props.linkUrl : "";
    const link = linkText ? <a href={linkUrl} target="_blank" style={{ color: 'blue', 'fontSize': '16px' }}><i className="fa fa-external-link" /> {linkText}</ a> : null;

    let element = <h5 className="c-fieldset__subheader" style={style}>{props.children} {link}</h5>;
    if (subHeaderLevel > 1) {
        style.opacity = "0.75";
        element = <h6 className="c-fieldset__subheader" style={style}>{props.children} {link}</h6>;
    }

    return (element);
};

FieldsetSubHeader.propTypes = {
    children: PropTypes.node,
    level: PropTypes.number,
    linkText: PropTypes.string,
    linkUrl: PropTypes.string
};

export default FieldsetSubHeader;
